var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImg = function SvgImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 165,
    viewBox: "0 0 292 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.8356 127.266H53.4046C49.705 123.86 47.3459 118.703 47.3459 112.93V108.689C47.3459 96.4002 38.4261 86.4381 27.4227 86.4381C16.1438 86.4381 6.9996 76.2257 6.9996 63.6287C6.9996 51.0317 16.1428 40.8192 27.4227 40.8192H30.769C41.7724 40.8192 50.6922 30.8572 50.6922 18.5687C50.6922 8.31289 58.1357 0 67.3173 0H197.217C207.436 0 215.721 9.25232 215.721 20.6664C215.721 28.4687 211.849 35.2605 206.134 38.7777H228.952C238.468 38.7777 246.182 46.7515 246.182 56.5874C246.182 68.3751 255.427 77.93 266.831 77.93H270.298C281.99 77.931 291.467 87.7265 291.467 99.8099C291.467 111.893 281.99 121.689 270.3 121.689C258.896 121.689 249.651 131.245 249.651 143.031V147.101C249.651 156.937 241.937 164.91 232.421 164.91H152.242C151.637 164.968 151.025 165 150.405 165H18.8376C8.43357 165 -3.05176e-05 156.553 -3.05176e-05 146.133C-0.00101472 135.713 8.4326 127.266 18.8356 127.266Z",
    fill: "url(#paint0_linear_10562_44399)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.467 117.642L146.169 144L191.871 117.642L146.169 91.2844L100.467 117.642Z",
    fill: "#031FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100.467 110.578L146.169 136.936L191.871 110.578L146.169 84.2207L100.467 110.578Z",
    fill: "#031FEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.467 100.073L146.169 126.431L191.871 100.073L146.169 73.7153L100.467 100.073Z",
    fill: "#E4EAF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.675 63.8806L162.416 72.9081V90.9632L146.675 99.9907L130.935 90.9632V72.9081L146.675 63.8806ZM133.564 76.3594V89.4539L145.36 96.2189V83.1253L133.564 76.3586V76.3594ZM159.785 76.3594L147.99 83.1261V96.218L159.785 89.4531V76.3603V76.3594ZM146.675 66.8982L134.5 73.88L146.675 80.8627L158.85 73.88L146.675 66.8973V66.8982Z",
    fill: "#031FEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.169 126.431V73.7154L100.467 47.3577V100.073L146.169 126.431Z",
    fill: "url(#paint1_linear_10562_44399)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.345 126.431V73.7154L191.871 47.3577V100.073L146.345 126.431Z",
    fill: "url(#paint2_linear_10562_44399)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100.467 47.3578L146.169 73.7155L191.871 47.3578L146.169 21L100.467 47.3578Z",
    fill: "url(#paint3_radial_10562_44399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10562_44399",
    x1: 19.473,
    y1: 150,
    x2: 236.621,
    y2: 81.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10562_44399",
    x1: 100.467,
    y1: 86.8943,
    x2: 146.169,
    y2: 86.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10562_44399",
    x1: 9057.15,
    y1: 6967.06,
    x2: 1216.99,
    y2: 14111.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10562_44399",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.169 47.3578) scale(37.3165 37.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF",
    stopOpacity: 0.2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img.5b0519b4.svg";
export { ForwardRef as ReactComponent };